import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import { jsxs as _jsxs } from "react/jsx-runtime";
import _toConsumableArray from "/home/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useAvailableChannels } from '../../hooks/use-available-channels';
import SMSOption from './sms';
import { Container, ResponsiveHSpacer } from '@aftersale-next/ui';
import * as channel from '../../config/constants/channel';
import WhatsappOption from './whatsapp';
import DisableNotificationOption from './disable-notification';
import EmailOption from './email';
import { useNotificationChannel } from '../../hooks/use-notification-channel';
var not_disturb_channel = {
  name: 'Not Disturb',
  id: 'not_disturb',
  data: {}
};

function selectChannel(channelId, onClick) {
  switch (channelId) {
    case channel.SMS:
      return /*#__PURE__*/_jsx(SMSOption, {
        onClick: onClick
      }, "sms");

    case channel.WHATSAPP:
      return /*#__PURE__*/_jsx(WhatsappOption, {
        onClick: onClick
      }, "whatsapp");

    case channel.NOT_DISTURB:
      return /*#__PURE__*/_jsx(DisableNotificationOption, {
        onClick: onClick
      }, "not_disturb");

    case channel.EMAIL:
      return /*#__PURE__*/_jsx(EmailOption, {
        onClick: onClick
      }, "email");

    default:
      return /*#__PURE__*/_jsx(_Fragment, {});
  }
}

export default function ChannelSelectorList(props) {
  var enabledChannel = useNotificationChannel();
  var availableChannels = useAvailableChannels();
  var filteredChannels = availableChannels.filter(function (item) {
    return item.enabled && item.id !== (enabledChannel === null || enabledChannel === void 0 ? void 0 : enabledChannel.channel);
  });
  var channels = [].concat(_toConsumableArray(filteredChannels), [not_disturb_channel]);
  return /*#__PURE__*/_jsxs(Container, {
    fullWidth: true,
    children: [/*#__PURE__*/_jsx(ResponsiveHSpacer, {
      mobileSpace: "20px",
      defaultSpace: "0"
    }), channels.map(function (item) {
      return selectChannel(item.id, function () {
        return props.onSelect(item.id);
      });
    })]
  });
}